const layer = {
  background: 'white',

  container: {
    zIndex: '20',
  },
  overlay: {
    background: 'black-alpha-50',
  },
  responsiveBreakpoint: undefined,
  zIndex: '20',
};

export default layer;
